import { NumberFormatter } from '@repo/toolkit/number'
import Badge from '@repo/ui/badge'
import Box from '@repo/ui/box'
import DataTable, { Column } from '@repo/ui/data-table'
import { useQuery } from '@tanstack/react-query'

import { getMissionTypes } from '../../../../api/mission-types/get-mission-types'
import useTranslate from '../../../../lib/hooks/use-translate'
import { MissionTypeEnum } from '../../../../lib/types/enums/mission/mission-type.enum'
import { MissionType } from '../../../../lib/types/models/mission-type/mission-type'
import LoadingScreen from '../../../elements/loading/loading-screen'
import { QualificationTags } from '../../../elements/qualification-badge'

const StaffPersonalSpaceAatPayScale = () => {
  const { t } = useTranslate()

  const { data: missionTypes, isPending } = useQuery({
    queryKey: ['mission-types', MissionTypeEnum.STAFF],
    queryFn: () =>
      getMissionTypes({ filter: { type: MissionTypeEnum.STAFF }, sort: { title: 'asc' } })
  })

  const columns: Column<MissionType>[] = [
    {
      accessorKey: 'title',
      header: t('staff.personal.space.pay.scale.aat.table.title'),
      enableSorting: false
    },
    {
      accessorKey: 'qualifications',
      header: t('staff.personal.space.pay.scale.aat.table.qualification'),
      enableSorting: false,
      cell: ({ row }) => <QualificationTags qualifications={row.original.qualifications} />
    },
    {
      accessorKey: 'pay',
      header: t('staff.personal.space.pay.scale.aat.table.pay'),
      enableSorting: false,
      cell: ({ row }) => {
        const pay = row.original.pay
        return pay ? (
          <Badge variant={'primary'} text={NumberFormatter.roundToTwoDecimalPlaces(pay)} />
        ) : (
          '-'
        )
      }
    }
  ]

  if (isPending || !missionTypes) return <LoadingScreen />

  return (
    <Box className="px-5">
      <DataTable<MissionType>
        columns={columns}
        paginated={false}
        manualSorting={false}
        data={missionTypes.data}
        rowCount={missionTypes.total}
      />
    </Box>
  )
}

export default StaffPersonalSpaceAatPayScale
